import React from "react";
import PageContainer from "../../src/components/container/Container";

export default function CodeOfConduct() {
  return (
    <PageContainer 
      title="Code of Conduct - CodeElan Technologies" 
      description="Learn about CodeElan Technologies' commitment to fostering an inclusive and respectful environment for all participants."
    >
      {/* Hero Section */}
      <section className="hero-section contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div className="hero-content">
                  <div className="hero-accent"></div>
                  <h1 className="hero-title">
                    <span className="text-primary">Code of Conduct</span>
                  </h1>
                  <p className="hero-subtitle">
                    Our commitment to fostering an inclusive and respectful environment for all participants
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Code of Conduct Content */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="policy-content">
                <div className="policy-intro">
                  <p className="policy-description">
                    All participants of CodeElan Technologies are expected to abide
                    by our Code of Conduct, both online and during in-person events
                    that are hosted and/or associated with CodeElan Technologies.
                  </p>
                </div>

                <div className="policy-section">
                  <h2 className="policy-section-title">The Pledge</h2>
                  <p className="policy-text">
                    In the interest of fostering an open and welcoming environment,
                    we pledge to make participation in our project and our community
                    a harassment-free experience for everyone, regardless of age,
                    body size, disability, ethnicity, gender identity and
                    expression, level of experience, nationality, personal
                    appearance, race, religion, or sexual identity and orientation.
                  </p>
                </div>

                <div className="policy-section">
                  <h2 className="policy-section-title">The Standards</h2>
                  <p className="policy-text">
                    Examples of behaviour that contributes to creating a positive
                    environment include:
                  </p>
                  <ul className="policy-list">
                    <li>Using welcoming and inclusive language</li>
                    <li>Being respectful of differing viewpoints and experiences</li>
                    <li>Gracefully accepting constructive criticism</li>
                    <li>Referring to people by their preferred pronouns and using gender-neutral pronouns when uncertain</li>
                  </ul>

                  <p className="policy-text">
                    Examples of unacceptable behaviour by participants include:
                  </p>
                  <ul className="policy-list">
                    <li>Trolling, insulting/derogatory comments, public or private harassment</li>
                    <li>Publishing others' private information, such as a physical or electronic address, without explicit permission</li>
                    <li>Not being respectful to reasonable communication boundaries, such as 'leave me alone,' 'go away,' or 'I'm not discussing this with you.'</li>
                    <li>The usage of sexualised language or imagery and unwelcome sexual attention or advances</li>
                    <li>Swearing, usage of strong or disturbing language</li>
                    <li>Demonstrating the graphics or any other content you know may be considered disturbing</li>
                    <li>Starting and/or participating in arguments related to politics</li>
                    <li>Assuming or promoting any kind of inequality including but not limited to: age, body size, disability, ethnicity, gender identity and expression, nationality and race, personal appearance, religion, or sexual identity and orientation</li>
                    <li>Other conduct which you know could reasonably be considered inappropriate in a professional setting</li>
                  </ul>
                </div>

                <div className="policy-section">
                  <h2 className="policy-section-title">Enforcement</h2>
                  <p className="policy-text">
                    Violations of the Code of Conduct may be reported by sending an
                    email to info@codeelan.com. All reports will be reviewed and
                    investigated and will result in a response that is deemed
                    necessary and appropriate to the circumstances. Further details
                    of specific enforcement policies may be posted separately. We
                    hold the right and responsibility to remove comments or other
                    contributions that are not aligned to this Code of Conduct, or
                    to ban temporarily or permanently any members for other
                    behaviours that they deem inappropriate, threatening, offensive,
                    or harmful.
                  </p>
                </div>

                <div className="policy-section">
                  <h2 className="policy-section-title">Contact Us</h2>
                  <p className="policy-text">
                    If you have any questions about this Code of Conduct or need to report a violation, please contact us:
                  </p>
                  <ul className="policy-list">
                    <li>By email: info@codeelan.com</li>
                    <li>By visiting this page on our website: <a href="/contactus" className="text-primary">Contact Us</a></li>
                    <li>By phone number: +91-8208650598</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
}
